import { shallowEqual } from 'react-redux';
import { getToken, removeRefreshToken, removeToken } from './http-service';
import { fetchCustomerAddresses } from "./../../states/customer-address/customer-address.slice";
import { fetchShoppingCart } from "states/shopping-cart/shopping-cart.slice";
import { fetchBranches } from "states/branch/branch.slice";
import { useAppDispatch } from "app.hook";
import { useEffect } from "react";
import { preLoadingAppFinish } from "states/global-value/global-value.slice";
import { getProfileAPI } from "states/account/account.api";
import { fetchBranchOrderPickupSetting } from 'states/branch-order-pickup-setting/order-pickup-setting.slice';
async function handleGetProfile() {
  try {
    let result = await getProfileAPI();
    let isRegularRole = result.data.roles?.filter((role) => role.name.toLowerCase() === "regular").length > 0;
    if (!isRegularRole) {
      removeToken();
      removeRefreshToken();
    }
  } catch {

  }
}
export default function useFetchAppData() {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchBranches());
    dispatch(fetchBranchOrderPickupSetting());
    if(getToken() !== null){
      handleGetProfile();
      dispatch(fetchCustomerAddresses())
      .then((value) => {
        dispatch(preLoadingAppFinish());
        if (value.meta.requestStatus === "fulfilled") {
          dispatch(fetchShoppingCart());
        }
      });
    }else{
      dispatch(preLoadingAppFinish());
    }
  }, []);
}
